import React, { memo } from 'react';
import { VehiclePin, ErrorBoundary, } from 'components';
import { Marker, InfoWindow } from '@react-google-maps/api'
import { vehiclesStatusTypes } from 'constants/environment'
export default memo(({
    location,
    showVehicleIcon = false,
    showVehicleName,
    name,
}) => {

    return (
        <ErrorBoundary>
            <Marker
                title={location?.name}
                clickable={false}
                icon={showVehicleIcon && {
                    url: ""
                }}
                draggable={false}
                position={{ lat: location?.lat, lng: location?.lng }}
            >
                {
                    showVehicleIcon &&
                    <InfoWindow>
                        <VehiclePin
                            icon={"vehicle"}
                            showVehicleName={showVehicleName}
                            name={name}
                            cursor={"pointer"}
                            backgroundColor={location?.vehicle?.icon_background_color || "#fff"}
                            borderColor={vehiclesStatusTypes?.[location?.status]?.color || "#000"}
                            iconColor={location?.vehicle?.icon_color || "#000"}
                            textOptions={true}
                            position={"relative"}
                            optionsIcons={{
                                height: "33px"
                            }}
                        />
                    </InfoWindow>
                }
            </Marker>
        </ErrorBoundary>
    )
})